import React, { useRef, useState, useContext } from "react";
import EstoqueParceiroGrid from "./grid";

import { Box, IconButton, Tooltip } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import NovoEstoqueParceiroFragment from "./novo";
import EstoqueParceiro from "../../components/classes/EstoqueParceiro";
import Parceiro from "../../components/classes/Parceiro";
import AutocompleteCentroEstoque from "../../components/common/AutocompleteCentroEstoque";
import { UserContext } from "../../App";

export default function EstoqueParceiroDetalhes(
  props: EstoqueParceiroDetalhesPropsTypes
) {
  const user: any = useContext(UserContext);
  const [pageState, setPageState] = useState<number>(0);
  const [selectedEstoqueParceiro, setSelectedEstoqueParceiro] =
    useState<EstoqueParceiro>();
  const [centro, setCentro] = useState<string>();

  return (
    <>
      {/* {pageState == 0 ? (
          <Tooltip title="Novo Registro">
            <span>
              <IconButton onClick={handleNewEstoqueParceiro} disabled={user.isSuporte}>
                <InsertDriveFileIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="Voltar">
            <IconButton onClick={handleBack}>
              <AssignmentReturnIcon />
            </IconButton>
          </Tooltip>
        )} */}

      {pageState == 1 ? (
        <NovoEstoqueParceiroFragment
          onSubmit={handleBack}
          estoqueParceiro={selectedEstoqueParceiro}
          parceiro={props.parceiro}
          centro={props.parceiro.codigoCentroEspelho.toString()}
          key={selectedEstoqueParceiro?.id}
        />
      ) : null}

      <EstoqueParceiroGrid
        parceiro={props.parceiro}
        centro={props.parceiro.codigoCentroEspelho.toString()}
        handleUpdateEstoqueParceiro={handleUpdateEstoqueParceiro}
        setSelectedEstoqueParceiroupdater={setSelectedEstoqueParceiro}
        key={Date.now()}
      />
    </>
  );

  function handleNewEstoqueParceiro() {
    return setPageState(1);
  }

  function handleUpdateEstoqueParceiro() {
    setPageState(0);
    setPageState(1);
  }

  function handleBack() {
    setSelectedEstoqueParceiro(undefined);
    return setPageState(0);
  }
}

interface EstoqueParceiroDetalhesPropsTypes {
  parceiro: Parceiro;
}
